import { Auth } from 'aws-amplify'
import React, { useEffect } from 'react'
import PageContainer from '../../components/PageContainer'
import AsyncStorage from "@react-native-async-storage/async-storage";

const LogoutScreen = () => {
    useEffect(() => {
        (async () => {
            try {
                await Auth.signOut();
                await AsyncStorage.clear(); // Clears local storage upon logout
            } catch (error) {
                console.error("Error signing out:", error);
            }
        })();
    }, []);

    return (
      <PageContainer loading />
    );
};

export default LogoutScreen